/**
 * ダッシュボード 受注
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/dashboard/manifests`

 const dashboard_manifest = {

  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     *
     * @param dispatch
     * @param commit
     * @param state
     * @param search_type
     * @param target_date
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { search_type, target_date }) {
      const params = {
        target_date: target_date,
        search_type: search_type,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
 }
 export default dashboard_manifest
